// extracted by css-extract-rspack-plugin
export default {"root":"List-module__root___GnFfc","item":"List-module__item___ffPFY"};